/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import Hero from "./Hero";
import WhyJoinWealthy from "./WhyJoinWealthy";
import Calculator from "./Calculator";
import SuccessStories from "./SuccessStories";
import ExclusiveWebinar from "./ExclusiveWebinar";
import ProductPartners from "./ProductPartners";
import InThePress from "./InThePress";
import OurProducts from "./OurProducts";
import AdvisorsCarousel from "./AdvisorsCarousel";
import Register from "./Register";

export {
  Hero,
  WhyJoinWealthy,
  Calculator,
  SuccessStories,
  ExclusiveWebinar,
  ProductPartners,
  InThePress,
  OurProducts,
  AdvisorsCarousel,
  Register
};
